import React from "react";
import useResponsiveFlags from "../../hooks/useResponsiveFlags";
export default function WrapperContainer(props) {
  const { isDesktop, isDesktopLogin } = useResponsiveFlags();
  const desktopScreen = props.loggedin ? isDesktopLogin : isDesktop;
  // remove wrapper , apply min height on the inside container, apply flex on each parent container , separate form div, separate buttons div, flex grow on the form div 
  
  return (
    <div
      style={
        props.loggedin
          ? {
              marginLeft: isDesktop ? "300px" : "0",
              paddingTop: isDesktop ? "" : "101px",
            }
          : undefined
      }
    >
      <div
        style={{
          padding: isDesktop ? "10px 24px 20px 24px" : "6px 4px 10px 4px",
        }}
      >
        {props.buttons ? (
          <>
            <div
              className={`d-flex align-items-center ${
                !isDesktop ? "justify-content-between" : ""
              }`}
              style={{ paddingRight: "0.8rem" }}
            >
              <p className="screen-title">{props.title}</p>
              {props.buttons}
            </div>
          </>
        ) : (
          <p className="screen-title">{props.title}</p>
        )}
        <hr
          style={{
            ...(props.buttons && { marginTop: "0" }),
            marginLeft: isDesktop ? "0" : "0.8rem",
            marginRight: isDesktop ? "0" : "0.8rem",
          }}
        />
        <div
          style={{
            maxWidth: desktopScreen ? props.maxwidth : "",
            margin: "0 0.8rem",
          }}
        >
          {props.content}
        </div>
      </div>
    </div>
  );
}
